import { CellSelection } from '../cell-selection';
import { TableMap } from '../table-map';
import { selectionCell } from './selection-cell';
// Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for
// convenience.
export function selectedRect(state) {
  var sel = state.selection;
  var $pos = selectionCell(sel);
  if (!$pos) {
    throw new Error("selectedRect: invalid $pos for selection");
  }
  var table = $pos.node(-1);
  var tableStart = $pos.start(-1);
  var map = TableMap.get(table);
  var rect;
  if (sel instanceof CellSelection) {
    rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
  } else {
    rect = map.findCell($pos.pos - tableStart);
  }
  rect.tableStart = tableStart;
  rect.map = map;
  rect.table = table;
  return rect;
}